<script setup lang="ts">
  import { computed } from 'vue';
  import { QualityRecordModal } from '@/shared/ui';
  import { DocumentRevision } from '@/entities/Document';
  import { useBranchLogo } from '@/entities/Branch/@x/Document';

  const props = withDefaults(
    defineProps<{
      title: string;
      revision: DocumentRevision | null;
      modalTitle: string;
      documentInfoTitle: string;
      qualityRecordCode?: string;
      documentNumber?: string;
      documentRevision?: number | null;
      documentRevisionLabel?: string;
      printPillLabel?: string;
      printCompact?: boolean;
      hasDocumentPrefix?: boolean;
    }>(),
    {
      printCompact: false,
      hasDocumentPrefix: true,
    }
  );

  const emit = defineEmits<{
    close: [];
  }>();

  const handleClose = () => {
    emit('close');
  };

  const { currentLogoUrl, handleLogoError, resolvePrintableLogoSrc } = useBranchLogo();

  const documentInfo = computed(() => {
    const prefix = props.revision?.document.prefix;
    const documentPrefix = prefix ?? '';
    const rev = props.revision?.revision;
    const revisionLabel = rev == null ? '' : `REV.${rev}`;
    const fixedNumber = props.documentNumber;
    if (fixedNumber) {
      const revForHeader = props.documentRevision ?? rev;
      const fixedRevision =
        props.documentRevisionLabel ??
        (revForHeader == null ? revisionLabel : `REV.${revForHeader}`);
      return {
        code: fixedNumber,
        revision: fixedRevision,
        documentNumber: fixedNumber,
        documentPrefix,
      };
    }
    return {
      code: prefix,
      revision: revisionLabel,
      documentNumber: `${prefix ?? ''}/REV.${rev ?? ''}`,
      documentPrefix,
    };
  });
</script>
<template>
  <QualityRecordModal
    :modal-title="modalTitle"
    :form-title="documentInfoTitle"
    :document-info="documentInfo"
    :quality-record-code="qualityRecordCode"
    :pill-label="printPillLabel"
    :compact="printCompact"
    :has-document-prefix="hasDocumentPrefix"
    :logo-url="currentLogoUrl"
    :resolve-logo-src="resolvePrintableLogoSrc"
    @logo-error="handleLogoError"
    @close="handleClose"
  >
    <slot
      :document-info="documentInfo"
      :revision="revision"
      :document-number="revision?.revision"
    />
  </QualityRecordModal>
</template>
